import { configureCompat } from 'vue'

// Global console.warn filter to eliminate persistent noise from legacy plugins
const originalWarn = console.warn
console.warn = (...args) => {
    const msg = args[0]
    if (typeof msg === 'string' && (
        msg.includes('(deprecation') ||
        msg.includes('[BootstrapVue warn]') ||
        msg.includes('already been registered') ||
        msg.includes('already been applied') ||
        msg.includes('Invalid deprecation config')
    )) {
        return
    }
    originalWarn(...args)
}

// Configure Vue Compartibility Mode

configureCompat({
    MODE: 2,
    WATCH_ARRAY: 2,
    GLOBAL_EXTEND: 2,
    GLOBAL_MOUNT: 2,
    GLOBAL_PROTOTYPE: 2,
    COMPONENT_V_MODEL: 2,
    INSTANCE_EVENT_EMITTER: 2,
    INSTANCE_LISTENERS: 2,
    COMPONENT_FUNCTIONAL: 2
})
